var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-gauge',{attrs:{"gaugeValueClass":"d-none","width":_vm.size,"height":_vm.size,"minValue":0,"maxValue":3,"value":_vm.value,"options":_vm.gaugeOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }